/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const LocationBasedEventIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Location Based Event',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M20.5 14.054a.494.494 0 0 0-.5.5v19.782a.494.494 0 0 0 .846.353L26.51 29h8c.446 0 .479-.726.225-.98L20.846 14.2a.489.489 0 0 0-.346-.146Z"
    />
    <path d="M2 2v10.476A10.735 10.735 0 0 1 6 10.3V6h22v11.158l4 4V2Z" />
    <path
      d="M9 12.367a8.25 8.25 0 0 0-8.25 8.25C.75 25.173 9 35.57 9 35.57s8.25-10.4 8.25-14.953A8.25 8.25 0 0 0 9 12.367Zm0 11.75a3.5 3.5 0 1 1 3.5-3.5 3.5 3.5 0 0 1-3.5 3.5Z"
    />
  </svg>`;
};
